module.exports = __webpack_public_path__ + "img/hot_face.4a39293e.gif";